import { api } from './client';

type Envelope<T> = { data: T };

export type GroupRole = 'signer' | 'approver' | 'cc' | 'witness' | 'for_info';
export type GroupAuthMethod = 'email_otp' | 'sms_otp' | 'access_code' | 'asan_imza' | 'none';

export type GroupMember = {
  id: string;
  email: string;
  name: string;
  role: GroupRole;
  authMethod: GroupAuthMethod;
  signingOrder: number;
};

export type GroupView = {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  createdBy: { name: string; email: string };
  members: GroupMember[];
};

export type GroupMemberInput = {
  email: string;
  name: string;
  role?: GroupRole;
  authMethod?: GroupAuthMethod;
  signingOrder?: number;
};

export const recipientGroupsApi = {
  async list(): Promise<GroupView[]> {
    const { data } = await api.get<Envelope<GroupView[]>>('/recipient-groups');
    return data.data;
  },

  async create(input: { name: string; description?: string; members: GroupMemberInput[] }): Promise<GroupView> {
    const { data } = await api.post<Envelope<GroupView>>('/recipient-groups', input);
    return data.data;
  },

  async update(
    uuid: string,
    input: { name?: string; description?: string | null; members?: GroupMemberInput[] },
  ): Promise<GroupView> {
    const { data } = await api.patch<Envelope<GroupView>>(`/recipient-groups/${uuid}`, input);
    return data.data;
  },

  async delete(uuid: string): Promise<void> {
    await api.delete(`/recipient-groups/${uuid}`);
  },
};
